import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const LeadershipEntryRequirements = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Direct Route",
      content: `•	An accredited Bachelor’s degree (MQF Level 6 or equivalent) in any discipline from a recognised institution.
`,
    },
    {
      id: 2,
      title: "ESBD Route (Postgraduate Diploma Entry)",
      content: `•	Students who have finished the Postgraduate Diploma (60 ECTS credits), in Global Business & Strategic Leadership, at the European School of Business & Diplomacy (ESBD) can seamlessly advance to Semester 3 of the Masters program.

      This route is ideal for those seeking staged progression or returning learners.
`,
    },
    {
      id: 3,
      title: "RPL Route (Recognition of Prior Learning)",
      content: `We welcome applications from experienced professionals who do not hold a traditional degrees but show evidence of: 

•	A minimum of 5 years of progressive work experience in leadership, management, or relevant roles
•	Evidence of professional development, certifications, or non-formal education aligned with programme outcomes 
•	A successful interview and/or portfolio review to determine suitability 
This route values experiential learning and professional practice as a foundation for academic progression.
`,
    },
    {
      id: 4,
      title: "English Language Requirements",
      content: `The following qualifications meet our English language requirement:

•	Native English speakers
•	TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
•	Ielts (Minimum score: 5.5)
•	Cambridge ESOL (CAE, Minimum score: C1)
•	English as the language of instruction in formal education
•	Equivalent qualifications you wish to be considered.
`,
    },
    {
      id: 5,
      title: "Identity Check",
      content: `Applicants need to provide valid identification during the application process and they must confirm their identity through a live Zoom meeting at the beginning of the course.`,
    },
    {
      id: 6,
      title: "IT Requirements",
      content: `Participants must have access to:
      
•	Internet-enabled devices (computer, laptop, tablet)
•	Speakers/headphones, webcam, and microphone
•	Video-based teaching platforms and the course’s Virtual Learning Environment (VLE)
`,
    },
  ];

  return (
    <div className="scroll-mt-44 my-10" id="entry-requirements">
      <div className="bg-sddarkgray py-5">
        <div className="max-w-6xl mx-auto px-2 md:px-10 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Entry Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className={`w-full text-left py-2 px-3 transition-colors focus:outline-none rounded-md ${
                    activeSection === section.id
                      ? "bg-white"
                      : "bg-sddarkorange hover:bg-white"
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <span className="font-bold">{section.title}</span>
                    <span>
                      {activeSection === section.id ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-gray-600 border-t border-gray-300 mt-1 rounded-md">
                    <p className="text-white whitespace-pre-line text-sm">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadershipEntryRequirements;
